import { useTranslation } from "react-i18next";
import { Badge, type badgeVariants } from "~/atoms/badge";
import type { VariantProps } from "class-variance-authority";
import { UserStatus, DocumentVersionStatus } from "../config/types";

type BadgeVariant = VariantProps<typeof badgeVariants>["variant"];

const statusVariant: Record<DocumentVersionStatus | UserStatus, BadgeVariant> =
  {
    [DocumentVersionStatus.draft]: "secondary",
    [DocumentVersionStatus.archived]: "destructive",
    [DocumentVersionStatus.published]: "success",
    [UserStatus.pending]: "warn",
    [UserStatus.active]: "success",
    [UserStatus.deactivated]: "secondary",
    [UserStatus.deleted]: "destructive",
  };

export const FieldStatus = ({
  status,
}: {
  status?: DocumentVersionStatus | UserStatus;
}) => {
  const { t } = useTranslation();

  const statusLabel: Record<DocumentVersionStatus | UserStatus, string> = {
    [DocumentVersionStatus.draft]: t(($) => $.commons.documentStatus.draft),
    [DocumentVersionStatus.published]: t(
      ($) => $.commons.documentStatus.published,
    ),
    [DocumentVersionStatus.archived]: t(
      ($) => $.commons.documentStatus.archived,
    ),
    [UserStatus.active]: t(($) => $.commons.userStatus.active),
    [UserStatus.deactivated]: t(($) => $.commons.userStatus.deactivated),
    [UserStatus.pending]: t(($) => $.commons.userStatus.pending),
    [UserStatus.deleted]: t(($) => $.commons.userStatus.deleted),
  };

  if (!status) {
    return null;
  }

  return <Badge variant={statusVariant[status]}>{statusLabel[status]}</Badge>;
};
